import MappingModel from "./MappingModel";

export default class MappingResponseModel {
  meta: MappingModel = new MappingModel();
  data: MappingModel[] = [];
}
